import {
  ADD_SERVICE,
  ADD_SERVICE_FAILURE,
  ADD_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
  EDIT_SERVICE, EDIT_SERVICE_FAILURE, EDIT_SERVICE_SUCCESS,
  GET_ALL_PAGE_SERVICES,
  GET_ALL_PAGE_SERVICES_FAILURE,
  GET_ALL_PAGE_SERVICES_SUCCESS,
  GET_SERVICE, GET_SERVICE_FAILURE, GET_SERVICE_SUCCESS
} from "./actionTypes";


const initialState = {
  loading: false,
  error: "",
  services: [],
  section: {},
  page :  {}
};

const stores = (state = initialState, action) => {
  switch (action.type) {

    // get service  
    case GET_ALL_PAGE_SERVICES:
      state = {
        ...state,
        error: "",
        loading: true,
        services: [],
        page : {}
      };
      break;

    case GET_ALL_PAGE_SERVICES_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        services: action.payload.page.sections,
        page : action.payload.page
      };
      break;

    case GET_ALL_PAGE_SERVICES_FAILURE:
      state = {
        ...state,
        error: action.payload,
        services: [],
        loading: false,
        page : {}
      };
      break;

    // get service  
    case GET_SERVICE:
      state = {
        ...state,
        error: "",
        loading: true,
        service: {}
      };
      break;

    case GET_SERVICE_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        service: action.payload.section,
      };
      break;

    case GET_SERVICE_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    // ADD service  
    case ADD_SERVICE:
      state = {
        ...state,
        error: "",
        loading: true,
        service: {}
      };
      break;

    case ADD_SERVICE_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        service: {},
        services: action.payload.sections,
      };
      break;

    case ADD_SERVICE_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false
      };
      break;

    // edit service  
    case EDIT_SERVICE:
      state = {
        ...state,
        error: "",
        loading: true,
        service: {}
      };
      break;

    case EDIT_SERVICE_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        service: action.payload,
      };
      break;

    case EDIT_SERVICE_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    // ADD service  
    case DELETE_SERVICE:
      state = {
        ...state,
        error: "",
        loading: true,
      };
      break;

    case DELETE_SERVICE_SUCCESS:
      const servicesAfterDelete = [
        ...state?.services?.filter((service) => service?.slug !== action.payload.slug),
      ];
      state = {
        ...state,
        error: "",
        loading: false,
        services: servicesAfterDelete,
      };
      break;

    case DELETE_SERVICE_FAILURE:
      state = {
        ...state,
        error: action.payload,
        loading: false
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};

export default stores;

